"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SessionReq model module.
 * @module model/SessionReq
 * @version 1.0.0
 */
var SessionReq = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SessionReq</code>.
   * @alias module:model/SessionReq
   */
  function SessionReq() {
    _classCallCheck(this, SessionReq);

    SessionReq.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SessionReq, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>SessionReq</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SessionReq} obj Optional instance to populate.
     * @return {module:model/SessionReq} The populated <code>SessionReq</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SessionReq();

        if (data.hasOwnProperty('email')) {
          obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
        }

        if (data.hasOwnProperty('password_digest')) {
          obj['password_digest'] = _ApiClient.default.convertToType(data['password_digest'], 'String');
        }
      }

      return obj;
    }
  }]);

  return SessionReq;
}();
/**
 * @member {String} email
 */


SessionReq.prototype['email'] = undefined;
/**
 * @member {String} password_digest
 */

SessionReq.prototype['password_digest'] = undefined;
var _default = SessionReq;
exports.default = _default;